module.exports = __webpack_public_path__ + "img/am.06509258.svg";